export default __webpack_public_path__ + "static/media/cpThaiBirthdayBanner.47fbef66.jpg";